import React from 'react'
import { useAppDispatch } from '../../../hooks/redux/hooks';
import { logout } from '../authSlice';

const Logout = () => {
    const dispatch = useAppDispatch();
    const logoutHandler = () => {
        dispatch(logout());
    }

  return (
    <div onClick={logoutHandler}>Sign out</div>
  )
}

export default Logout